<template>
    <div>
        <PropHeader title="页面组件"></PropHeader>
        <p v-for="(item, index) in menu" :key="index" @click="onComponentClick($event, item)"
            style="padding:15px 0 0 15px">
            {{ item.name }}
        </p>
    </div>
</template>

<script>
import emitter from '@/utils/eventbus';

import { ComponentListMenu } from '@/common/const'

import PropHeader from '@/components/PropHeader.vue';
export default {
    name: "DecorationMenu",
    components: { PropHeader },
    data() {
        return {
            menu: ComponentListMenu
        }
    },
    methods: {
        onComponentClick(event, component) {
            const newComponent = JSON.parse(JSON.stringify(component))
            console.log('onComponentClick', newComponent)
            emitter.emit('onAddComponent', newComponent)
        }
    }
}
</script>

<style scoped lang="less">

</style>